const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
const lowPowerDevice =
  navigator.connection?.saveData === true ||
  (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 2);

if (!motionQuery.matches && !lowPowerDevice && 'IntersectionObserver' in window) {
  const selector = '.content-for-layout > .shopify-section:not([data-global-scroll-reveal="off"])';
  const observed = new WeakSet();

  const reveal = (section) => {
    section.dataset.globalScrollReveal = 'visible';
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '200px 0px',
      threshold: 0,
    }
  );

  const prepare = (section) => {
    if (!(section instanceof HTMLElement) || observed.has(section)) return;
    observed.add(section);

    const rect = section.getBoundingClientRect();
    if (!rect.height) {
      reveal(section);
      return;
    }
    const isInitiallyVisible = rect.top < window.innerHeight * 0.88;

    if (isInitiallyVisible) {
      reveal(section);
      return;
    }

    section.dataset.globalScrollReveal = 'pending';
    observer.observe(section);
  };

  document.querySelectorAll(selector).forEach(prepare);
  requestAnimationFrame(() => document.documentElement.classList.add('scroll-reveal-ready'));

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.matches?.(selector) ? event.target : event.target?.querySelector?.(selector);
    if (section) prepare(section);
  });
}
